import React, { useEffect, useRef, useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import TestimonialCard from "./TestimonialCard";
import supabase from "../../SupaBase";
import Aos from "aos";

const Testimonials = () => {
	const [feedback, setFeedback] = useState([]);
	const [loading, setLoading] = useState(true);
	const scrollRef = useRef(null);

	useEffect(() => {
		const fetchFeedback = async () => {
			const { data, error } = await supabase
				.from("feedback")
				.select("*")
				.order("created_at", { ascending: false });
			if (error) {
				console.error("Error fetching feedback:", error);
			} else {
				setFeedback(data);
			}
			setLoading(false);
		};
		fetchFeedback();
		Aos.init({ duration: 1000 });
	}, []);

	const scroll = (direction) => {
		if (scrollRef.current) {
			const isDesktop = window.innerWidth >= 1024; // lg breakpoint

			if (isDesktop) {
				// Desktop: Calculate exact width for one card including gap
				const containerWidth = scrollRef.current.clientWidth;
				const cardWidth = containerWidth / 3; // Each card takes 1/3 of container width
				const scrollAmount = cardWidth + 5.5;

				scrollRef.current.scrollBy({
					left: direction === "left" ? -scrollAmount : scrollAmount,
					behavior: "smooth"
				});
			} else {
				// Mobile: Move by full row (2 cards)
				const containerWidth = scrollRef.current.clientWidth;
				const scrollAmount = containerWidth + 8; // Full container width for mobile

				scrollRef.current.scrollBy({
					left: direction === "left" ? -scrollAmount : scrollAmount,
					behavior: "smooth"
				});
			}
		}
	};

	return (
		<div className="lg:py-32 pb-40 flex flex-col items-center font-bai mx-[-25px]">
			<div className='text-2xl mb-10'>
				<span className='text-neon font-extrabold' data-aos="zoom-in-left" data-aos-offset="120">&lt;</span>
				<span data-aos="zoom-in-up" data-aos-offset="120"> Testimonials </span>
				<span className='text-neon font-extrabold' data-aos="zoom-in-right" data-aos-offset="120">/ &gt;</span>
			</div>
			<div className="relative w-full">
				{loading ? (
					<div className="flex justify-center items-center w-full h-[25vh]">
						<div className="w-10 h-10 border-4 border-t-[#00fffc] border-gray-800 rounded-full animate-spin"></div>
					</div>
				) :
					<>
						{feedback.length > 0 ?
							<div className="overflow-hidden w-full flex items-center gap-4">
								{/* Left Arrow - Positioned Outside */}
								<button
									className="bg-[#00fffc] text-black lg:p-3 p-1 rounded-full shadow-md hover:bg-white transition duration-300 ease-in-out flex-shrink-0"
									onClick={() => scroll("left")}
									data-aos="fade-up-right" data-aos-offset="110"
								>
									<FaArrowLeft className="lg:text-2xl" />
								</button>
								<div
									ref={scrollRef}
									className="lg:flex lg:space-x-4 
									grid grid-rows-2 grid-flow-col auto-cols-[minmax(100%,_1fr)] gap-2 overflow-x-auto scrollbar-hide scroll-smooth"
									style={{ scrollSnapType: "x mandatory" }}
								>
									{feedback.map((testimonial, index) => (
										<TestimonialCard key={index} {...testimonial} />
									))}
								</div>
								{/* Right Arrow - Positioned Outside */}
								<button
									className="bg-[#00fffc] text-black lg:p-3 p-1 rounded-full shadow-md hover:bg-white transition duration-300 ease-in-out flex-shrink-0"
									onClick={() => scroll("right")}
									data-aos="fade-up-left" data-aos-offset="110"
								>
									<FaArrowRight className="lg:text-2xl" />
								</button>
							</div>
							:
							<div className="flex flex-col gap-4 items-center w-full relative">

								{/* Main text with gradient */}
								<h3 className="text-lg md:text-xl font-semibold text-[#00fffc]">
									No Testimonials Yet
								</h3>

								{/* Subtitle */}
								<p className="text-gray-400 text-center text-xs md:text-sm max-w-md mx-auto leading-relaxed">
									Be the first to share your experience and help others discover what makes this portfolio special
								</p>
							</div>
						}
					</>
				}
			</div>
		</div>
	);
};

export default Testimonials;